function valorBooleano(valor: any): boolean {
  return valor === true || valor === 1 || valor === '1';
}

function obtenhaIdEmpresa(empresa: any): number {
  return Number(empresa?.id || empresa?.empresaId || 0);
}

export function podeUsarRetiradaInterloja(
  contexto: any,
  atendimentoPreparado: boolean,
  subTipo: string,
  lojaExecutora: any,
  cliente: any
): boolean {
  return valorBooleano(contexto?.retiradaInterlojaAtiva)
    && atendimentoPreparado
    && subTipo === 'retirada'
    && obtenhaIdEmpresa(lojaExecutora) > 0
    && Number(cliente?.contatoId || cliente?.id || 0) > 0;
}

export function listeLojasProprietariasInterloja(contexto: any, lojaExecutora: any): any[] {
  const empresaExecutoraId = obtenhaIdEmpresa(lojaExecutora);

  return (contexto?.lojas || [])
    .filter((loja: any) =>
      valorBooleano(loja?.ativa)
      && obtenhaIdEmpresa(loja) > 0
      && obtenhaIdEmpresa(loja) !== empresaExecutoraId
    )
    .slice()
    .sort((a: any, b: any) => String(a?.nome || '').localeCompare(String(b?.nome || '')));
}

export function crieDadosPreparacaoInterloja(cliente: any, lojaProprietaria: any, lojaExecutora: any) {
  return {
    empresaProprietariaId: obtenhaIdEmpresa(lojaProprietaria),
    empresaExecutoraId: obtenhaIdEmpresa(lojaExecutora),
    empresaOrigemId: Number(cliente?.empresaId || cliente?.lojaOrigem?.id || 0),
    contatoId: Number(cliente?.contatoId || cliente?.id || 0),
    tipoPedido: 'RETIRADA'
  };
}
